module.exports = __webpack_public_path__ + "img/brand_twitter.d4c1a1a6.svg";